<template>
  <div class="ma-4">
    <ClientNav />
    <v-row dense>
      <v-col cols="12">
        <v-card>
          <v-card-title style="background-color: #2b3990">
            <span class="headline white--text">{{ titleForm }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-card-title>Medication Change Policy</v-card-title>
                  <v-divider class="mb-4"></v-divider>
                  <ul>
                    <li>
                      If a change is made (dose changes, medication is
                      discontinued, medication is added), text nurse within 1
                      hour of visit, with info about the change (med name,
                      doctor, etc.)
                    </li>
                    <li>
                      Nurse will call pharmacy by the end of the day to ensure
                      change was received
                    </li>
                    <li>
                      Add medication to MAR upon returning to the house (incl.
                      med name, doc, dose, instructions)
                    </li>
                    <li>
                      By the next afternoon, new or changed medication can be
                      picked up from office, unless otherwise specified
                    </li>
                    <li>
                      Notifications will be sent electronically to all staff and
                      medical department
                    </li>
                    <li>
                      All staff must sign below to acknowledge they are aware of
                      the medication change and will comply
                    </li>
                    <li>
                      Nurse will follow up within a few days to ensure change
                      has been implemented
                    </li>
                    <li>
                      If it is a pain medication or antibiotic that must be
                      started as soon as possible, the policy will differ
                      slightly
                    </li>
                    <ul>
                      <li>
                        Take prescription straight to company designated or
                        other nearby pharmacy
                      </li>
                      <li>Inform nurse what medication was filled and where</li>
                      <li>
                        If refills are needed, nurse will inform the pharmacy
                        and we will get the prescription transferred to them
                      </li>
                    </ul>
                  </ul>
                  <div>
                    By signing below, I acknowledge that I have been made aware
                    of the following medication change and have been trained on
                    how it is to be used. I will comply with the change:
                    Medication change (include medication name, dose change,
                    date changed, doctor name):
                  </div>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <DatePicker
                    :default-date="newDate"
                    v-model="newDate"
                    label="Date of Medication Change"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    label="Medication"
                    v-model="newMedication"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    label="Staff"
                    v-model="staff"
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="4">
                  <v-checkbox
                    label="Staff Signature"
                    @click="addSignature"
                    v-model="isStaffSigned"
                  ></v-checkbox>
                  <v-text-field v-model="newSignature" readonly></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="4">
                  <DatePicker
                    :default-date="newSignatureDate"
                    v-model="newSignatureDate"
                    label="Staff Signature Date"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="white--text"
              color="#259647"
              @click="addMedChange()"
              v-if="$route.params.action === 'add' && !isAuditorRole"
              >Save
            </v-btn>
            
              <v-btn 
              fab 
              small
              @click="showPrintModal()"
              class="mr-8 mb-2 white--text"
              color="#2b6993"
              elevation="4"
              v-if="$route.query.new"
              >
              <v-icon>print</v-icon>
          </v-btn>
            <v-btn
              class="white--text"
              color="#259647"
              @click="updateMedChange()"
              v-if="$route.query.new && !isAuditorRole"
              >Update</v-btn
            >
            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <Foot />
  </div>
</template>

<script>
import axios from "axios";
import ClientNav from "@/components/ClientNav";
import Foot from "@/components/Footer";
import DatePicker from "@/components/DateTimePickers/DatePicker.vue";
import DateTimeUtil from "../../../../utils/date-time.util";
import PrintUtil from "../../../../utils/print-util";
import { Notyf } from "notyf";
import "notyf/notyf.min.css";

const notyf = new Notyf({
  duration: 3000,
  position: {
    y: "top",
  },
  dismissible: true,
});

const url = require("../../../client_config/config").url;

export default {
  components: {
    DatePicker,
    ClientNav,
    Foot,
  },
  data: function () {
    return {
      headers: [
        {
          text: "Date of Medication Change",
          align: "start",
          sortable: true,
          value: "Date",
        },
        { text: "Medication", value: "Medication" },
        { text: "Staff", value: "Staff" },
        { text: "Signed", value: "Signature" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dialog: false,
      newMedChange: false,
      msg: false,
      search: "",
      text: "",
      medChange: {},
      tempData: [],
      users: [],
      staff: localStorage.getItem("Name"),
      clientID: this.$route.params.clientID,
      userID: localStorage.getItem("userID"),
      titleForm: "Medication Change Policy",
      newDate: "",
      newMedication: "",
      newDescription: "",
      newSignature: "",
      newStaffSignature: "",
      newSignatureDate: "",
      isLoading: true,
      newStaff: "",
      isStaffSigned: false,
      token: localStorage.getItem('token')
    };
  },

  async mounted() {
      window.addEventListener('keydown', async (event) => {
          PrintUtil.handleKeydown(event, this.generateDownloadUrl, this.medChangeID, this.token, 'MedicationChange');
      });
  },  

  beforeDestroy() {
      window.removeEventListener('keydown', (event) => {
          PrintUtil.handleKeydown(event, this.generateDownloadUrl, this.medChangeID, this.token,'MedicationChange');
      });
  },

  computed: {
    generateDownloadUrl() {      
      return `${url}/medChange/print-pdf?id=${this.medChangeID}&clientId=${this.clientID}`;
    },
    isAuditorRole() {
      return localStorage.getItem("userRole") === 'Auditor'
    }
  },

  watch: {},

  created() {
    if (this.$route.query?.id) {
      this.getMedChange();
    }
  },

  methods: {
    initialize() {
      this.medChanges = [];
    },

    viewMedChange(item) {
      this.titleForm = "Viewing Medication Change";
      this.dialog = true;
      this.editMedChange = true;
      this.newMedChange = false;
      this.newDate = DateTimeUtil.toLocalDate(item.Date);
      this.newSignature = item.Signature;
      this.newSignatureDate = DateTimeUtil.toLocalDate(item.SignatureDate);
      this.newMedication = item.Medication;
      this.newStaff = item.Staff;
      this.medChangeID = item._id;

      if (item.Signature) {
        this.isStaffSigned = true;
      }
    },

    clear() {
      this.newDate = "";
      this.newSignature = "";
      this.newSignatureDate = "";
      this.newMedication = "";
    },

    close() {
      this.$router.go(-1);
      this.clear();
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async updateMedChange() {
      let currentDate = new Date();
      let medChangeDate = new Date(
        `${
          this.newDate
        } ${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`
      );
      let signatureDate = new Date(
        `${
          this.newSignatureDate
        } ${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`
      );

      let request_body = {
        Date: DateTimeUtil.toUTCISOString(medChangeDate),
        Signature: this.newSignature,
        SignatureDate: DateTimeUtil.toUTCISOString(signatureDate),
        Medication: this.newMedication,
        Staff: this.staff,
        ClientID: this.clientID,
      };

      try {
        const response = await axios.put(
          `${url}/medChange/${this.medChangeID}`,
          request_body
        );

        if (response.status !== 200) {
          notyf.error(
            "There was an error updating the medication change form."
          );
          return;
        }

        notyf.success("The medication change has been updated successfully.");
      } catch (e) {
        console.log(e);
      } finally {
        this.close();
      }
    },

    getMedChange() {
      this.isLoading = true;
      axios
        .get(`${url}/medChange/${this.$route.query.id}`)
        .then((res) => {
          this.medChange = res.data.medChange;
          this.viewMedChange(this.medChange);
        })
        .finally(() => (this.isLoading = false));
    },

    async addMedChange() {
      let currentDate = new Date();
      let medChangeDate = new Date(
        `${
          this.newDate
        } ${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`
      );
      let signatureDate = new Date(
        `${
          this.newSignatureDate
        } ${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`
      );

      let request_body = {
        Date: DateTimeUtil.toUTCISOString(medChangeDate),
        Signature: this.newSignature,
        SignatureDate: DateTimeUtil.toUTCISOString(signatureDate),
        Medication: this.newMedication,
        Staff: this.staff,
        ClientID: this.clientID,
      };

      try {
        const response = await axios.post(`${url}/medChange`, request_body);

        if (response.status !== 200) {
          notyf.error(
            "There was an error creating the medication change form."
          );
          return;
        }
        notyf.success("The medication change has been added successfully.");
      } catch (e) {
        console.log(e);
      } finally {
        this.close();
      }
    },

    addSignature() {
      this.newSignature = this.staff + " - " + new Date();
    },    

    async showPrintModal() {
        PrintUtil.showPrintOption(this.generateDownloadUrl, this.medChangeID, this.token,'MedicationChange');
    },
  },
};
</script>
<style>
@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}
</style>
